module.exports = __webpack_public_path__ + "static/media/control_entre_carga2.ec579a73.svg";